import api from "./api.js";

export default class ScrapApi {
  static async getColumnScrapList(data) {
    return await api.get(`api/column-scrap`, data);
  }

  static async getConsultingScrapList(data) {
    return await api.get(`api/consulting-scrap`, data);
  }

  static async getLectureScrapList(data) {
    return await api.get(`api/lecture-scrap`, data);
  }
}
